import * as React from "react";
import { cn } from "@/lib/utils";

interface InfoRowProps extends React.HTMLAttributes<HTMLDivElement> {
  icon: React.ReactNode;
  label: string;
  value: React.ReactNode;
  iconBgColor?: string;
  iconColor?: string;
}

const InfoRow = React.forwardRef<HTMLDivElement, InfoRowProps>(
  (
    {
      icon,
      label,
      value,
      iconBgColor = "bg-muted",
      iconColor = "text-muted-foreground",
      className,
      ...props
    },
    ref
  ) => {
    return (
      <div
        ref={ref}
        className={cn(
          "flex items-center gap-3 py-3",
          className
        )}
        {...props}
      >
        <div
          className={cn(
            "flex h-10 w-10 shrink-0 items-center justify-center rounded-lg",
            iconBgColor
          )}
        >
          <div className={cn("h-5 w-5", iconColor)}>{icon}</div>
        </div>
        <div className="flex-1 min-w-0">
          <p className="text-sm text-muted-foreground">{label}</p>
          <div className="text-sm font-medium truncate">{value}</div>
        </div>
      </div>
    );
  }
);
InfoRow.displayName = "InfoRow";

export { InfoRow };
export type { InfoRowProps };
